'use client';

import { useEffect } from 'react';

import { pinEmbedPalette } from '../lib/embedPalette';
import { embedPaletteFromParams } from '../lib/embedParams';

/**
 * Forces the widget site to render in light mode by default.
 *
 * The main-app's colorPalette bridge (attached by the app effects bootstrap) resolves the
 * visitor's own theme (from `kalshi-color-palette` in localStorage, their account's
 * server-persisted `colorPalette`, or `prefers-color-scheme`) and applies it, which would
 * otherwise snap the widget site dark for anyone who uses dark mode on the main Kalshi site.
 *
 * Pins through `pinEmbedPalette` rather than writing the CSS variables directly: the bridge
 * re-applies the resolved palette on every auth/query-cache/media-query/pathname change, and
 * the session restore that `startAppEffects` kicks off lands after this effect has run.
 *
 * Skips when the embed asked for dark, meaning we are inside an embed iframe where the
 * StateManager (or the banner page) is already handling the palette. (React fires child
 * effects before parent effects, so without this guard ForceLightMode would override the
 * StateManager's dark setting.) The accepted param spellings live in `embedPaletteFromParams`
 * so this and the routes that pin their own palette cannot drift apart.
 */
export function ForceLightMode() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isEmbedDark = embedPaletteFromParams(params) === 'dark';
        const isPreviewDark = localStorage.getItem('widget-preview-theme') === 'dark';
        if (!isEmbedDark && !isPreviewDark) {
            pinEmbedPalette('light');
        }
    }, []);

    return null;
}
